<template>
  <div :class="$style.topbar">
    <!-- <div class="mr-4 d-none d-sm-block">
      <cui-language-switcher />
    </div>
    <div class="mb-0 mr-auto d-xl-block d-none">
      <cui-actions />
    </div> -->
    <cui-breadcrumbs />

    <div class="ml-3 mr-3" v-if="user.environment === 'development'">
      <a-tag color="red">MEPX TEST OKRUŽENJE</a-tag>
    </div>

    <div class="d-xl-block d-none mr-0 ml-auto">
      <cui-user-menu />
    </div>
  </div>
</template>

<script>
// import CuiLanguageSwitcher from './LanguageSwitcher'
// import CuiActions from './Actions'
import { mapState } from 'vuex'
import CuiUserMenu from './UserMenu'
import CuiBreadcrumbs from '@/components/cleanui/layout/Breadcrumbs'

export default {
  components: {
    // CuiLanguageSwitcher,
    // CuiActions,
    CuiBreadcrumbs,
    CuiUserMenu,
  },
  computed: {
    ...mapState(['user']),
  },
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
